import { render, staticRenderFns } from "./Ripple.vue?vue&type=template&id=1c9801e7&scoped=true&"
import script from "./Ripple.vue?vue&type=script&lang=js&"
export * from "./Ripple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9801e7",
  null
  
)

export default component.exports